import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import { makeStyles } from "@material-ui/core/styles";

import MelodicaIcon from "../imgs/melodica.png";
import MetallophoneIcon from "../imgs/metallophone.png";
import SnareDrumIcon from "../imgs/snare_drum.png";
import TambourineIcon from "../imgs/tambourine.png";
import XylophoneIcon from "../imgs/xylophone.png";
import { lesson3Player } from "../share";

const useStyles2 = makeStyles((theme) => ({
  root: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 8,
  },
  img: {
    width: "60px",
  },
  buttonGroupWrapper: {
    transform: "scale(0.75)",
    marginTop: 8,
  },
}));

function makeIcon(Icon) {
  return function (props) {
    const { soleFlag, muteFlag, handleSoleClick, handleMuteClick } = props;
    const classes = useStyles2(props);
    return (
      <div className={classes.root}>
        <img className={classes.img} src={Icon} alt="" />
        <div className={classes.buttonGroupWrapper}>
          <ButtonGroup
            size="small"
            color="primary"
            aria-label="small outlined button group"
          >
            <Button
              variant={soleFlag ? "contained" : "outlined"}
              onClick={handleSoleClick}
            >
              オン
            </Button>
            <Button
              variant={muteFlag ? "contained" : "outlined"}
              onClick={handleMuteClick}
            >
              オフ
            </Button>
          </ButtonGroup>
        </div>
      </div>
    );
  };
}

const Melodica = makeIcon(MelodicaIcon);
const Metallophone = makeIcon(MetallophoneIcon);
const SnareDrum = makeIcon(SnareDrumIcon);
const Tambourine = makeIcon(TambourineIcon);
const Xylophone = makeIcon(XylophoneIcon);

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    backgroundColor: "#fff",
  },
  resetButtom: {
    position: "absolute",
    top: -40,
    left: 8,
  },
}));

const initialState = {
  sole: {
    melodica: false,
    metallophone: false,
    snareDrum: false,
    tambourine: false,
    xylophone: false,
  },
  mute: {
    melodica: false,
    metallophone: false,
    snareDrum: false,
    tambourine: false,
    xylophone: false,
  },
};

function InstrumentMenu() {
  const classes = useStyles();
  const [enabledMap, set] = useState(initialState);

  function createHandleMute(name) {
    return () => {
      const newState = {
        sole: {
          ...enabledMap.sole,
          [name]: false,
        },
        mute: {
          ...enabledMap.mute,
          [name]: !enabledMap.mute[name],
        },
      };
      lesson3Player.updateVolume(newState);
      set(newState);
    };
  }

  function createHandleSoleClick(name) {
    return () => {
      const newState = {
        mute: {
          ...enabledMap.mute,
          [name]: false,
        },
        sole: {
          ...enabledMap.sole,
          [name]: !enabledMap.sole[name],
        },
      };
      lesson3Player.updateVolume(newState);
      set(newState);
    };
  }

  function resetClick() {
    lesson3Player.updateVolume(initialState);
    set(initialState);
  }

  return (
    <div className={classes.root}>
      <div className={classes.resetButtom}>
        <Button
          variant="outlined"
          size="medium"
          color="primary"
          onClick={resetClick}
        >
          リセット
        </Button>
      </div>
      <div style={{ height: 124 }}>
        <Xylophone
          soleFlag={enabledMap.sole.xylophone}
          muteFlag={enabledMap.mute.xylophone}
          handleMuteClick={createHandleMute("xylophone")}
          handleSoleClick={createHandleSoleClick("xylophone")}
        />
      </div>
      <div style={{ height: 124 }}>
        <Metallophone
          soleFlag={enabledMap.sole.metallophone}
          muteFlag={enabledMap.mute.metallophone}
          handleMuteClick={createHandleMute("metallophone")}
          handleSoleClick={createHandleSoleClick("metallophone")}
        />
      </div>
      <div style={{ height: 112 }}>
        <Melodica
          soleFlag={enabledMap.sole.melodica}
          muteFlag={enabledMap.mute.melodica}
          handleMuteClick={createHandleMute("melodica")}
          handleSoleClick={createHandleSoleClick("melodica")}
        />
      </div>
      <div style={{ height: 152 }}>
        <Tambourine
          soleFlag={enabledMap.sole.tambourine}
          muteFlag={enabledMap.mute.tambourine}
          handleMuteClick={createHandleMute("tambourine")}
          handleSoleClick={createHandleSoleClick("tambourine")}
        />
        <SnareDrum
          soleFlag={enabledMap.sole.snareDrum}
          muteFlag={enabledMap.mute.snareDrum}
          handleMuteClick={createHandleMute("snareDrum")}
          handleSoleClick={createHandleSoleClick("snareDrum")}
        />
      </div>
    </div>
  );
}

export default InstrumentMenu;
